import React from 'react'
import PropTypes from 'prop-types'
import Trash from 'react-feather/dist/icons/trash.js'

const ItSkillsSection = ({
  isOpen,
  toggleSection,
  combinedItSkills,
  openItSkills,
  toggleItSkill,
  selectedItSkills,
  handleSelectionChange,
  handleItSkillInputChange,
  handleDelete,
  isRegistrationFlow,
}) => {
  return (
    <div className="mb-5">
      <div className="mb-3 d-flex align-items-center" onClick={() => toggleSection('itSkills')} style={{ cursor: 'pointer' }}>
        <span className="form-title-chip rounded-circle mr-2">6</span>

        <h4 className="mb-0">Logiciels et outils informatiques</h4>

        <span className="ml-auto h3 text-secondary mb-0">{isOpen ? '-' : '+'}</span>
      </div>

      { isOpen && (
        <>
          {combinedItSkills.length === 0 ? (
            <div className="callout callout-secondary text-center col-md-7 mx-auto">
              Aucun outil informatique à comparer.
            </div>
          ) : (
            combinedItSkills.map((skill, index) => (
              <div key={skill._id} className="callout py-3">
                <div className="d-flex align-items-center" style={{ cursor: 'pointer' }}>
                  <div className="d-flex align-items-start mr-4 flex-grow-1" onClick={() => toggleItSkill(skill._id)}>
                    <>
                      {skill.isIdentical && <span className="badge badge-success mt-1 mr-3">Identique</span>}
                      {skill.isNew && <span className="badge badge-primary text-white mt-1 mr-3">Nouveau</span>}
                      {skill.isCurrent && <span className="badge badge-secondary mt-1 mr-3">Twineeds</span>}
                    </>

                    <h5 className="mb-0">{skill.name}</h5>
                  </div>

                  <div className="ml-auto d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm btn-round mr-3"
                      onClick={(e) => {
                        e.stopPropagation()
                        handleDelete('itSkills', index)
                      }}
                    >
                      <Trash/>
                    </button>

                    <span className="h4 text-secondary mb-0" onClick={() => toggleItSkill(skill._id)}>{openItSkills[skill._id] ? '-' : '+'}</span>
                  </div>
                </div>

                { openItSkills[skill._id] && (
                  <div className="row mt-3">
                    {/* Analyse Data Column */}
                    {skill.analyseData && (
                      <div className={`col-md-${skill.isCurrent ? '6' : '12'}`}>
                        <div className={`p-3 mb-3 border rounded ${skill.isCurrent && selectedItSkills[skill._id] !== 'analyseData' ? 'border-light' : ''}`}>
                          { skill.isCurrent && (
                            <div className="custom-control custom-switch mb-2">
                              <input
                                className="custom-control-input"
                                type="checkbox"
                                id={`itSkill-${skill._id}-analyse`}
                                checked={selectedItSkills && selectedItSkills[skill._id] === 'analyseData'}
                                onChange={() => handleSelectionChange('itSkills', skill._id, 'analyseData')}
                              />

                              <label className="custom-control-label" htmlFor={`itSkill-${skill._id}-analyse`}>
                                Nouvelle donnée du CV
                              </label>
                            </div>
                          )}

                          {skill.analyseData && (
                            <div style={{ opacity: skill.isCurrent && selectedItSkills && selectedItSkills[skill._id] !== 'analyseData' ? 0.5 : 1 }}>
                              <div className="form-group mb-0">
                                <label htmlFor={`itSkill-${skill._id}-analyse-name`}>Outil / Logiciel</label>

                                <input
                                  type="text"
                                  className="form-control"
                                  id={`itSkill-${skill._id}-analyse-name`}
                                  value={skill.analyseData.name}
                                  onChange={(e) => handleItSkillInputChange(index, 'analyseData', 'name', e.target.value)}
                                  disabled={selectedItSkills && selectedItSkills[skill._id] !== 'analyseData'}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Freelance Data Column */}
                    {skill.isCurrent && (
                      <div className={`col-md-${skill.isNew ? '6' : '12'}`}>
                        <div className={`p-3 mb-3 border rounded ${skill.isNew && selectedItSkills[skill._id] !== 'freelanceData' ? 'border-light' : ''}`}>
                          {skill.isNew && (
                            <div className="custom-control custom-switch mb-2">
                              <input
                                className="custom-control-input"
                                type="checkbox"
                                id={`itSkill-${skill._id}-freelance`}
                                checked={selectedItSkills && selectedItSkills[skill._id] === 'freelanceData'}
                                onChange={() => handleSelectionChange('itSkills', skill._id, 'freelanceData')}
                              />

                              <label className="custom-control-label" htmlFor={`itSkill-${skill._id}-freelance`}>
                                Donnée actuelle
                              </label>
                            </div>
                          )}

                          {skill.freelanceData && (
                            <div style={{ opacity: skill.isNew && selectedItSkills && selectedItSkills[skill._id] !== 'freelanceData' ? 0.5 : 1 }}>
                              <div className="form-group mb-0">
                                <label htmlFor={`itSkill-${skill._id}-freelance-name`}>Outil / Logiciel</label>

                                <input
                                  type="text"
                                  className="form-control"
                                  id={`itSkill-${skill._id}-freelance-name`}
                                  value={skill.freelanceData.name}
                                  onChange={(e) => handleItSkillInputChange(index, 'freelanceData', 'name', e.target.value)}
                                  disabled={selectedItSkills && selectedItSkills[skill._id] !== 'freelanceData'}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))
          )}
        </>
      )}
    </div>
  )
}

ItSkillsSection.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleSection: PropTypes.func.isRequired,
  combinedItSkills: PropTypes.array.isRequired,
  openItSkills: PropTypes.object.isRequired,
  toggleItSkill: PropTypes.func.isRequired,
  selectedItSkills: PropTypes.object.isRequired,
  handleSelectionChange: PropTypes.func.isRequired,
  handleItSkillInputChange: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  isRegistrationFlow: PropTypes.bool.isRequired,
}

ItSkillsSection.defaultProps = {
  isRegistrationFlow: false,
}

export default ItSkillsSection
